/**
 * @description VRM Forgot Password route config
 */

(function() {
    'use strict';

    angular.module('vrm.core')
        .config(ForgotPasswordRoute);

    /**
     * Configure Routing for Forgot Password State
     * @param $stateProvider
     * @constructor
     * @ngInject
     */
    function ForgotPasswordRoute($stateProvider) {

        $stateProvider
            .state('forgot-password', {
                url: '/forgot-password',
                views: {
                    "base": {
                        template: require('@/angular/views/core/forgot-password.html'),
                        controller: 'ForgotPasswordController'
                    }
                },
                data: {
                    skipLoginCheck: true,
                },
            });
    }

})();

